import React from 'react'
import { motion } from 'framer-motion'
import { X } from 'lucide-react'

export default function Terms({ onClose }) {
  const fade = {
    hidden: { opacity: 0, y: 50 },
    visible: i => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.05, duration: 0.6 }
    })
  }

  const clauses = [
    {
      h: '1. คำนิยาม',
      p: [
        '“บริษัท/เรา” หมายถึง บริษัท ควิซซี่ เอไอ จำกัด (Kuizy.ai Co., Ltd.) เลขทะเบียนนิติบุคคล 0-1234-56789-00 สำนักงานใหญ่: 123 ถ.วิทยุ แขวงลุมพินี เขตปทุมวัน กทม. 10330 ประเทศไทย',
        '“บริการ” หมายถึง แพลตฟอร์ม Kuizy.ai, เว็บไซต์, แอป, API, ส่วนเสริม, เนื้อหา, เอกสาร และซอฟต์แวร์ทั้งหมดที่บริษัทให้บริการ',
        '“ผู้ใช้” หมายถึง บุคคลหรือนิติบุคคลที่สร้างบัญชี หรือเข้าถึง/ใช้บริการ ไม่ว่าจะเสียค่าตอบแทนหรือไม่',
        '“เนื้อหาของผู้ใช้” หมายถึง ข้อสอบ, คำถาม, รูปภาพ, ไฟล์, ข้อมูลผลสอบ หรือสารสนเทศอื่นที่ผู้ใช้สร้าง/อัปโหลดเข้าสู่บริการ',
        '“ข้อมูลส่วนบุคคล” ตามนิยามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA) และ General Data Protection Regulation (GDPR)',
      ],
    },
    {
      h: '2. การยอมรับและการแก้ไขข้อกำหนด',
      p: [
        'การเข้าถึงหรือใช้บริการถือว่าผู้ใช้ตกลงผูกพันตามข้อกำหนดนี้ (“TOS”) และนโยบายอื่นที่อ้างถึง เช่น นโยบายความเป็นส่วนตัว, นโยบายคุกกี้, แนวทางเนื้อหา',
        'บริษัทอาจปรับปรุง TOS ได้ทุกเมื่อ หากมีการเปลี่ยนแปลงสาระสำคัญ บริษัทจะแจ้งผู้ใช้อย่างน้อย 7 วันก่อนมีผลบังคับใช้ เว้นแต่จำเป็นเร่งด่วนด้านความปลอดภัย',
        'การใช้บริการต่อหลังวันที่มีผลบังคับถือว่าผู้ใช้ยอมรับ TOS ฉบับแก้ไขแล้ว',
      ],
    },
    {
      h: '3. คุณสมบัติผู้ใช้และการลงทะเบียน',
      p: [
        'ผู้ใช้ต้องมีอายุอย่างน้อย 13 ปี หากกฎหมายท้องถิ่นกำหนดอายุมากกว่านี้ให้ใช้อายุตามกฎหมายท้องถิ่น (เช่น COPPA สหรัฐอเมริกา = 13 ปี, GDPR = 16 ปี)',
        'ผู้ใช้นิติบุคคลรับรองว่ามีอำนาจผูกพันองค์กรตามกฎหมาย',
        'ข้อมูลลงทะเบียนต้องถูกต้อง ครบถ้วน เป็นปัจจุบัน และผู้ใช้ต้องอัปเดตหากมีการเปลี่ยนแปลง',
        'ผู้ใช้ต้องเก็บรักษาชื่อผู้ใช้และรหัสผ่านเป็นความลับ บริษัทไม่รับผิดชอบความเสียหายจากการเข้าถึงบัญชีโดยไม่ได้รับอนุญาต',
      ],
    },
    {
      h: '4. แผนบริการ ค่าธรรมเนียม และการต่ออายุ',
      p: [
        'บริการแบบเสียค่าธรรมเนียม (“แผน Pro / Enterprise”) เป็นการชำระแบบล่วงหน้า (Pre-paid Subscription) รายเดือนหรือรายปี และต่ออายุโดยอัตโนมัติจนกว่าจะยกเลิก',
        'ค่าบริการจะถูกเรียกเก็บผ่านตัวประมวลผลการชำระเงินที่สอดคล้องมาตรฐาน PCI-DSS เช่น Stripe การทำธุรกรรมทั้งหมดเข้ารหัสผ่าน TLS 1.3',
        'ผู้ใช้สามารถยกเลิก Subscription ได้ทุกเมื่อ การยกเลิกจะมีผล ณ สิ้นงวดบิล การคืนเงินทำได้เฉพาะกรณีบริการขัดข้องร้ายแรงด้วยเหตุจากบริษัท และเป็นดุลยพินิจของบริษัท',
      ],
    },
    {
      h: '5. สิทธิทรัพย์สินทางปัญญา',
      p: [
        'ซอฟต์แวร์ โค้ดต้นฉบับ อินเทอร์เฟซ กราฟิก โลโก้ เครื่องหมายการค้า เครื่องหมายบริการ และเอกสารที่เกี่ยวข้องเป็นทรัพย์สินทางปัญญาของบริษัทตามกฎหมายไทยและระหว่างประเทศ',
        'ผู้ใช้รักษาลิขสิทธิ์ “เนื้อหาของผู้ใช้” แต่ให้สิทธิ์ใช้งานแบบไม่ผูกขาด แก่บริษัทในการประมวลผล จัดเก็บ สำรอง จัดรูปแบบ และแสดงผลตามจำเป็นเพื่อให้บริการ',
        'ห้ามผู้ใช้ทำวิศวกรรมย้อนกลับ (Reverse Engineering) คัดลอก เผยแพร่ หรือดัดแปลงซอฟต์แวร์ เว้นแต่ได้รับอนุญาตเป็นลายลักษณ์อักษร',
      ],
    },
    {
      h: '6. พฤติกรรมต้องห้าม',
      p: [
        'ห้ามใช้บริการเพื่อ: (ก) เนื้อหาละเมิดลิขสิทธิ์ ลามกอนาจาร ความรุนแรง ความเกลียดชัง หรือหมิ่นประมาท, (ข) สแปม Phishing มัลแวร์, (ค) เจาะระบบ ดัดแปลง โจมตีแบบ DDoS หรือสแกนช่องโหว่, (ง) ฝ่าฝืน PDPA, GDPR, CCPA, COPPA, Export-control หรือกฎหมายท้องถิ่นอื่น',
        'บริษัทอาจระงับบัญชี ลบเนื้อหา หรือดำเนินคดีทางแพ่ง/อาญาหากพบการละเมิด',
      ],
    },
    {
      h: '7. ข้อมูลส่วนบุคคล',
      p: [
        'การเก็บ ใช้ เปิดเผย และปกป้องข้อมูลส่วนบุคคลเป็นไปตาม “นโยบายความเป็นส่วนตัว” ซึ่งถือเป็นส่วนหนึ่งของ TOS นี้',
        'บริษัททำ Data Processing Agreement (DPA) กับผู้ประมวลผลข้อมูลย่อย (Sub-processors) และใช้ Standard Contractual Clauses (SCCs) สำหรับการโอนข้อมูลออกนอก EEA',
      ],
    },
    {
      h: '8. การรับประกัน การปฏิเสธความรับผิด และขีดจำกัด',
      p: [
        'บริการให้ “ตามสภาพ” (AS-IS) และ “ตามที่มี” (AS-AVAILABLE) บริษัทไม่รับประกันความถูกต้อง ความครบถ้วน ความปลอดภัย หรือความพร้อมใช้งานต่อเนื่อง',
        'บริษัทไม่รับผิดชอบความเสียหายอันเกิดจาก: การใช้งานผิดวิธี เหตุสุดวิสัย การหยุดให้บริการเพื่อบำรุงรักษา หรือการโจมตีทางไซเบอร์',
        'ขีดจำกัดความรับผิดรวมของบริษัทต่อผู้ใช้ทุกกรณีจำกัดสูงสุดไม่เกินค่าธรรมเนียมที่ผู้ใช้ชำระจริงภายใน 12 เดือนก่อนเกิดเหตุ',
      ],
    },
    {
      h: '9. การชดใช้ค่าเสียหาย (Indemnity)',
      p: [
        'ผู้ใช้ตกลงปกป้อง ชดใช้ และไม่ให้บริษัทและกรรมการ ผู้บริหาร พนักงาน และตัวแทน ต้องรับผิดจากการเรียกร้องหรือค่าเสียหายใด ๆ ที่เกิดจากการละเมิด TOS หรือกฎหมายโดยผู้ใช้',
      ],
    },
    {
      h: '10. ระยะเวลาและการยกเลิก',
      p: [
        'TOS มีผลตั้งแต่วันที่ผู้ใช้ยอมรับและคงอยู่จนกว่าจะมีการยกเลิกโดยฝ่ายใดฝ่ายหนึ่ง',
        'บริษัทสามารถยกเลิกหรือระงับบัญชีได้ทันทีหากพบการละเมิดร้ายแรง',
        'หลังยกเลิก สิทธิการเข้าถึงบริการทั้งหมดจะสิ้นสุดทันที แต่ข้อกำหนดเรื่องทรัพย์สินทางปัญญา การปฏิเสธความรับผิด ความลับทางธุรกิจ และกฎหมายที่ใช้บังคับยังคงมีผล',
      ],
    },
    {
      h: '11. กฎหมายและเขตอำนาจศาล',
      p: [
        'ข้อกำหนดนี้อยู่ภายใต้กฎหมายราชอาณาจักรไทย',
        'ข้อพิพาทใด ๆ ที่ไม่สามารถไกล่เกลี่ยกันได้ภายใน 30 วัน ให้ส่งฟ้องต่อศาลแพ่ง กรุงเทพมหานครเป็นศาลแรก',
      ],
    },
    {
      h: '12. ติดต่อ',
      p: [
        'อีเมลฝ่ายกฎหมาย: terms@kuizy.ai',
        'โทรศัพท์: +66 80-808-6001-5',
      ],
    },
  ]

  return (
    <section className="relative">
      <button
        className="fixed top-4 right-4 bg-white/80 backdrop-blur p-3 rounded-full shadow hover:bg-white z-[60]"
        onClick={onClose}
      >
        <X size={30} />
      </button>

      <div className="pt-20 pb-10 px-6 max-w-5xl mx-auto space-y-12">
        <motion.h1
          className="text-4xl md:text-5xl font-extrabold text-primary text-center"
          variants={fade}
          custom={0}
          initial="hidden"
          animate="visible"
        >
          เงื่อนไขการให้บริการ
        </motion.h1>

        {clauses.map((c, idx) => (
          <motion.div key={c.h} variants={fade} custom={idx + 1} initial="hidden" animate="visible">
            <h2 className="text-xl md:text-2xl font-bold text-secondary mb-3">{c.h}</h2>
            {c.p.map((line, i) => (
              <p key={i} className="text-base md:text-lg leading-relaxed text-gray-700 mb-2">{line}</p>
            ))}
          </motion.div>
        ))}
      </div>
    </section>
  )
}
